import classes from "./SiderContentC.module.css";
import { Menu, message } from "antd";

import signInSignUpLogo from "../../../assets/signInSignUp.png";
import { MdDashboard } from "react-icons/md";

import { Link } from "react-router-dom";

import axios from "axios";
import {BsFillGrid3X3GapFill} from 'react-icons/bs'
import {AiTwotoneRest} from 'react-icons/ai'

import { useNavigate } from "react-router-dom";
import { MdAssignmentTurnedIn } from "react-icons/md";
import {
  FaSignOutAlt,
  FaMoneyCheckAlt,
  
} from "react-icons/fa";

import {GiRuleBook} from 'react-icons/gi';

const { SubMenu } = Menu;

const SiderContentS = (props) => {
  const history = useNavigate();

  const handleLogout = (event) => {
    axios
      .get(props.url + "/api/v1/users/logout", {
        withCredentials: true,
      })
      .then((response) => {
        message.success({
          content: "Goodbye!!!! See You Again!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        history("/");
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  return (
    <>
      <img
        className={classes["SignInSignUpLogo"]}
        src={signInSignUpLogo}
        alt="Logo"
      />
      <Menu
        mode="inline"
        defaultSelectedKeys={["empDashboard"]}
        // defaultOpenKeys={["misc"]}
        style={{
          height: "100%",
          borderRight: 0,
          overflowY: "auto",
        }}
        theme="light"
      >
        <Menu.Item key="empDashboard" icon={<MdDashboard />}>
          <Link to="/payroll/dashboard" style={{ textDecoration: "none" }}>
            Dashboard
          </Link>
        </Menu.Item>

         {/* <SubMenu key="Masters" title="Masters" icon={<AiTwotoneRest />}>
          <Menu.Item key="indent-register">
            <Link
              to="/payroll/transection/employee"
              style={{ textDecoration: "none" }}
            >
              Employee Master
            </Link>
             </Menu.Item>
          <Menu.Item key="allowance-details">
            <Link
              to="/payroll/allowanceMaster/allowance-detalis"
              style={{ textDecoration: "none" }}
            >
              Allowance Master
            </Link>
             </Menu.Item>
          <Menu.Item key="shift-details " >
            <Link
              to="/payroll/shiftMaster/shift-details"
              style={{ textDecoration: "none" }}
            >
              Shift Master
            </Link>
             </Menu.Item>
          <Menu.Item key="team-details" >
            <Link
              to="/payroll/teamMaster/team-details"
              style={{ textDecoration: "none" }}
            >
              Team Master
            </Link>
             </Menu.Item>
          

          <Menu.Item key="holiday-details" >
            <Link
              to="/payroll/holidayMaster/holiday-details"
              style={{ textDecoration: "none" }}
            >
              Holiday Master
            </Link>
          </Menu.Item>

          </SubMenu> */}


        <SubMenu key="norms" title="Norms" icon = {<GiRuleBook />}>
                    <Menu.Item key="leaveNorms" >
                        <Link to = '/payroll/norms/leave-norms'  style={{ textDecoration: "none" }}>
                            Leave Norms
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="salaryNorms" >
                        <Link to = '/payroll/norms/salary-norms'    style={{ textDecoration: "none" }}>
                            Salary Norms
                        </Link>
                    </Menu.Item>
                    {/* <Menu.Item key="inoutNorm" >
                        <Link to = '/payroll/norms/inout-norms'    style={{ textDecoration: "none" }}>
                            InOut Norms
                        </Link>
                    </Menu.Item> */}
                    <Menu.Item key="advanceNorm" >
                        <Link to = '/payroll/norms/salary-advance'    style={{ textDecoration: "none" }}>
                            Salary Advance
                        </Link>
                    </Menu.Item>
                    
        </SubMenu>


        <SubMenu key="transactions" title="Transactions" icon = {<MdAssignmentTurnedIn />}>
                    <Menu.Item key="daily-attendance" >
                        <Link to = '/payroll/transactions/daily-attendance'    style={{ textDecoration: "none" }}>
                            Daily Attendance
                        </Link>
                    </Menu.Item>
                    {/* <Menu.Item key="leave" >
                        <Link to = '/payroll/transactions/leave'    style={{ textDecoration: "none" }}>
                            Leave Entry
                        </Link>
                    </Menu.Item> */}
                    <Menu.Item key="salary-processing" >
                        <Link to = '/payroll/transactions/salary-processing'    style={{ textDecoration: "none" }}>
                            Salary Processing
                        </Link>
                    </Menu.Item>
        </SubMenu>

        <SubMenu key="salarywadges" title="Salary and wadges" icon = {<FaMoneyCheckAlt />}>
                    <Menu.Item key="employee-data" >
                        <Link to = '/payroll/salarywadges/employee-data'  style={{ textDecoration: "none" }}>
                            Employee Data
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="attandance-data" >
                        <Link to = '/payroll/salarywadges/attandance-data'  style={{ textDecoration: "none" }}>
                            Attandance Data
                        </Link>
                    </Menu.Item>
                   
                </SubMenu>

      

        <SubMenu key="misc" title="Miscelleneous" icon = {<BsFillGrid3X3GapFill/>}>
                    {
                        props.miscList && props.miscList.length > 0
                        ?
                        <>
                            {
                                props.miscList.map(misc => {
                                    return(
                                        <Menu.Item key={misc.table_code} >
                                            <Link to = {'/payroll/misc/' + misc.slug}  style={{ textDecoration: 'none' }}>
                                                {misc.form_name}
                                            </Link>
                                        </Menu.Item>
                                    );
                                })
                            }
                        </>
                        :
                        null
                    }
                </SubMenu>

        <Menu.Item
          key="empLogout"
          onClick={(event) => handleLogout(event)}
          icon={<FaSignOutAlt style={{ color: "red", opacity: "0.7" }} />}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            Logout
          </Link>
        </Menu.Item>
      </Menu>
    </>
  );
};

export default SiderContentS;
